import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ValidateResponseService {
  validateClientEnabledForUploadFiles(response: any): boolean {
    let validate = true;

    if (response.documentUpload === undefined) {
      validate = false;
    }

    return validate;
  }
}
